import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';

export const SUPPORTED_LANGUAGES = ['en'] as const;
/**
 * Languages we can switch the layout direction for before they are translated.
 * `?lng=he` renders English strings with an RTL layout: a sanity check that every screen uses
 * logical CSS properties. Missing keys fall back to English.
 */
const QA_LANGUAGES = ['he'] as const;

export type Direction = 'ltr' | 'rtl';

const RTL_LANGUAGES = new Set(['ar', 'fa', 'he', 'ur', 'yi']);

export function directionFor(language: string): Direction {
  const base = language.toLowerCase().split('-')[0] ?? language;
  return RTL_LANGUAGES.has(base) ? 'rtl' : 'ltr';
}

function initialLanguage(): string {
  if (typeof window === 'undefined') return 'en';
  const requested = new URLSearchParams(window.location.search).get('lng');
  const allowed: readonly string[] = [...SUPPORTED_LANGUAGES, ...QA_LANGUAGES];
  return requested && allowed.includes(requested) ? requested : 'en';
}

function applyDocumentLanguage(language: string) {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = language;
  document.documentElement.dir = directionFor(language);
}

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en } },
  lng: initialLanguage(),
  fallbackLng: 'en',
  supportedLngs: [...SUPPORTED_LANGUAGES, ...QA_LANGUAGES],
  interpolation: { escapeValue: false }, // React already escapes.
  returnNull: false,
});

applyDocumentLanguage(i18n.language);
i18n.on('languageChanged', applyDocumentLanguage);

export default i18n;
